import "./StoryLibrary.module.css";
import Header from "@/reusable_sections/Header";
import DigitalSanctuary from "./sections/DigitalSanctuary";
import TherapeuticVideoCollection from "./sections/TherapeuticVideoCollection";
import FooterIntelligence from "@/reusable_sections/Footer";
export default function StoryLibraryPage() {
  return <div>
      <Header />
      <DigitalSanctuary />
      <TherapeuticVideoCollection />
      <FooterIntelligence />
    </div>;
}